import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HelpIcon from '@material-ui/icons/Help';
import LanguageIcon from '@material-ui/icons/Language';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Switch from '@material-ui/core/Switch';

import { LanguageNames } from 'lib/languages';
import strings from 'lib/strings';
import Strings from 'components/Strings';
import Stats from 'components/Stats';

const drawerWidth = 280;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    borderColor: '#ebebd8',
    background: '#f6f6e8'
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  listItemTextSecondary: {
    fontSize: '14px'
  }
});

class Sidebar extends React.Component {
  handleShowSidebar = () => {
    const { onShowSidebar } = this.props;
    onShowSidebar && onShowSidebar();
  };

  handleHideSidebar = () => {
    const { onHideSidebarClicked } = this.props;
    onHideSidebarClicked && onHideSidebarClicked();
  };

  handleHelpClicked = () => {
    const { onHelpClicked } = this.props;
    onHelpClicked && onHelpClicked();
  }

  handleLanguageClicked = language => () => {
    const { onLanguageClicked } = this.props;
    onLanguageClicked && onLanguageClicked(language);
  }

  handleToggle = name => () => {
    const { onFilterToggle } = this.props;
    onFilterToggle && onFilterToggle(name);
  }

  renderContent() {
    const { language, checked, isAdmin, classes, theme } = this.props;

    return (
      <React.Fragment>
        <div className={ classes.drawerHeader }>
          <IconButton onClick={ this.handleHideSidebar }>
            { theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon /> }
          </IconButton>
        </div>

        <Divider />

        <List component="nav">
          <ListItem button onClick={ this.handleHelpClicked }>
            <ListItemIcon><HelpIcon /></ListItemIcon>
            <ListItemText><Strings label="help_button" /></ListItemText>
          </ListItem>

          {
            strings.getAvailableLanguages().map(key => {
              return (
                language === key
                ? ''
                : (
                  <React.Fragment key={ key }>
                    <Divider />
                    <ListItem button onClick={ this.handleLanguageClicked(key) }>
                      <ListItemIcon><LanguageIcon /></ListItemIcon>
                      <ListItemText>{ LanguageNames[key] }</ListItemText>
                    </ListItem>
                  </React.Fragment>
                )
              )
            })
          }
        </List>

        <Divider />

        <List component="nav">
          <ListItem button onClick={ this.handleToggle('showFromIsrael') }>
            <ListItemText
              primary={ <Strings label="filter_from_israel" /> }
              secondary={ <Strings label="filter_from_israel_subtext" /> }
              classes={{
                secondary: classes.listItemTextSecondary
              }}
            />
            <ListItemSecondaryAction>
              <Switch
                checked={ checked.indexOf('showFromIsrael') !== -1 }
                onChange={ this.handleToggle('showFromIsrael') }
                color="primary"
              />
            </ListItemSecondaryAction>
          </ListItem>

          <Divider />

          <ListItem button onClick={ this.handleToggle('showFromGermany') }>
            <ListItemText
              primary={ <Strings label="filter_from_germany" /> }
              secondary={ <Strings label="filter_from_germany_subtext" /> }
              classes={{
                secondary: classes.listItemTextSecondary
              }}
            />
            <ListItemSecondaryAction>
              <Switch
                checked={ checked.indexOf('showFromGermany') !== -1 }
                onChange={ this.handleToggle('showFromGermany') }
                color="primary"
              />
            </ListItemSecondaryAction>
          </ListItem>

          { isAdmin && this.renderStats() }
        </List>
      </React.Fragment>
    );
  }

  renderStats() {
    return (
      <React.Fragment>
        <Divider />
        <Stats />
      </React.Fragment>
    )
  }

  render() {
    const { showSidebar, persistentSidebar, classes } = this.props;

    if (persistentSidebar) {
      return (
        <Drawer
          className={ classes.drawer }
          variant={ "persistent" }
          anchor="left"
          open={ showSidebar }
          classes={{
            paper: classes.drawerPaper
          }}
        >
          { this.renderContent() }
        </Drawer>
      );
    } else {
      return (
        <SwipeableDrawer
          className={ classes.drawer }
          anchor="left"
          open={ showSidebar }
          classes={{
            paper: classes.drawerPaper
          }}
          onOpen={ this.handleShowSidebar }
          onClose={ this.handleHideSidebar }
        >
          { this.renderContent() }
        </SwipeableDrawer>
      );
    }
  }
}

export default withStyles(styles, { withTheme: true })(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js